export default __webpack_public_path__ + "mini-icon-ios-13@2x.png";